<template>
    <div class="tx-product-border" data-product-preview>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'TxProductBorder',
    }
</script>

<style scoped lang="scss">
    .tx-product-border {
        height: 100%;
        border: 12px solid black;
        border-radius: 5px;
        box-shadow: 0 4px 8px 0 #0f0f0fe3, 0 6px 20px 0 #222222ba;
        position: relative;
        overflow: hidden;
        padding: 40px;
        background: white;
    }
</style>

